import { createFileRoute, useMatches } from '@tanstack/react-router';
import { SiteLayout } from '../../layout/SiteLayout';
import { getLocale } from '../../paraglide/runtime';

// Pathless layout mirroring the old SiteLayout route groups. Each leaf route
// declares its footer (and the landing route its hero nav) via `staticData`;
// this reads the deepest non-empty one and renders the shared Nav + main +
// Footer around the routed <Outlet />.
export const Route = createFileRoute('/_site')({ component: SiteRoute });

function SiteRoute() {
  const matches = useMatches();
  const hint = [...matches]
    .reverse()
    .map((m) => m.staticData)
    .find((d) => d !== undefined && Object.keys(d).length > 0);
  // Message functions read the locale when they render and nothing re-renders
  // them when it changes, so a navigation that crosses languages (a Chinese
  // page linking to an English one) remounts the shell rather than leaving a
  // Chinese nav over an English page.
  return (
    <SiteLayout
      key={getLocale()}
      footer={hint?.footer ?? 'full'}
      landing={hint?.landing ?? false}
    />
  );
}
